import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../../Components/Globals/Navbar';
import { navLinks } from '../../Data/data';

const SITE_NAME = 'Juli Juneau';

// Tab title from the navbar's own labels, e.g. '/glass/featured' -> 'Featured Works'
const pageTitle = (pathname) => {
    if (pathname === '/') return SITE_NAME;
    if (/^\/shop\/main\/[^/]+$/.test(pathname)) return null; // the item page uses the piece's name
    if (pathname.startsWith('/juli+dashboard')) return `Dashboard · ${SITE_NAME}`;
    if (pathname === '/login') return `Log In · ${SITE_NAME}`;

    const pages = navLinks.flatMap((item) => [{ title: item.itemTitle, link: item.link }, ...item.dropdownItems]);
    const page = pages.find(({ link }) => link && link !== '/' && (pathname === link || pathname.startsWith(`${link}/`)));
    return page ? `${page.title} · ${SITE_NAME}` : SITE_NAME;
};

const MainLayout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const title = pageTitle(pathname);
        if (title) document.title = title;
    }, [pathname]);

    return (
        <div className='flex flex-col flex-container min-h-screen bg-black'>
            <Navbar />

            <div className='flex min-h-[calc(100vh-40px)] max-w-screen'>
                <Outlet />
            </div>
        </div>
    )
}

export default MainLayout
